// extracted by mini-css-extract-plugin
export default {"authMenu":"UserMenu_authMenu__5qBp7","title":"UserMenu_title__uiW13","button":"UserMenu_button__310Zp","active":"UserMenu_active__hTRwj"};